<script setup>
  import { ref, onBeforeMount, computed } from "vue";
  import { useCompanyStore } from "@/stores/company";
import { useAreasStore } from "@/stores/areas";
import { useUiStore } from "@/stores/ui";

  const props = defineProps({
    sitesOptions : Array,
  });

  const emit = defineEmits(['refresh']);
  const areasStore = useAreasStore();
  const uiStore = useUiStore();
  const company_id = useCompanyStore().companyId;
  const getModalInfo = computed(() => uiStore.modalData);
  const getModalAction = computed(() => uiStore.modalAction);

  let site = ref(null);
  let area = ref(null);
  let id = ref(null);
  let isLoadingAreas = ref(null);
  let areasOptions = ref([]);

  let isSubmitted = ref(false);

  const changeSiteVal = () => {
    area.value = null
    areasOptions.value = [];
    if(site.value){
      isLoadingAreas.value = true;
      areasStore.fetchParentAreas({
        siteId :site.value.id,
        companyId : company_id,
      }).then((res) => {
        if(res.data && res.data.length){
          areasOptions.value = res.data.filter((obj)=>{
            if(obj.id != id.value) return obj
          });
        }
        isLoadingAreas.value = false;
      });
    }
  }
  
  const resetStoreData = () =>{
    uiStore.resetModalStore();
  };

  const onSubmit = () => {
    isSubmitted.value = true;
    let data = {
      id : id.value,
      site_id: site.value.id,
      parent_id: area.value.id,
      company_id: company_id,
    }

    areasStore.moveArea(data)
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });
  };

  onBeforeMount( () => {
    if(getModalInfo.value && getModalInfo.value.data_type == 'area' && getModalAction.value == 'move_location'){
      id.value = getModalInfo.value.id;
    }
  });
</script>

<template>
  <DModal v-if="getModalAction === 'move_location'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Move Location </template>

    <template #body>
      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="site"
          inputId="site"
          :options="props.sitesOptions"
          optionLabel="name"
          dataKey="id"
          class="w-full"
          filter
          filterPlaceholder="Search by site name"
          :disabled="!props.sitesOptions.length"
          @change="changeSiteVal"
        />
        <label for="site">Site</label>
      </FloatLabel>

      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="area"
          inputId="area"
          :options="areasOptions"
          optionLabel="name"
          dataKey="id"
          class="w-full"
          filter
          filterPlaceholder="Search by location name"
          :disabled="!site || isLoadingAreas"
          :loading="isLoadingAreas"
        />
        <label for="area">Location</label>
      </FloatLabel>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!site || !area || isSubmitted" 
          @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">
            Move <span v-if="isSubmitted"  class="spinner-sm" role="status" aria-hidden="true" ></span>
          </button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
        </div>
      </div>
    </template>
  </DModal>
</template>
